var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-embed"},[_c('VideoPlayer',{staticClass:"video-player",attrs:{"item":_vm.photoList[0],"index":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }